module.exports = __webpack_public_path__ + "static/media/role-4.176c51f.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cha/audio/role-4.wav
// module id = XGiG
// module chunks = 1